import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import ImprovementReducer from './ImprovementReducer';
import ConfigReducer from './ConfigReducer';
import ValidationReducer from './ValidationReducer';

const rootReducer = (history) =>
  combineReducers({
    improvements: ImprovementReducer,
    validations: ValidationReducer,
    config: ConfigReducer,
    router: connectRouter(history),
  });

export default rootReducer;
